const SECTION_SELECTOR = '#pdp-section-inquiry';
const ROW_SELECTOR = '#simpAskQuestion .accordionSimpQA ul li';
const ANSWER_SELECTOR = '.ow-qna-answer-panel, .simpAnswerHolder, [class*="answer" i]';
const QUESTION_SELECTOR = '.simpQuestionHolder, [class*="question" i]';
const AUTHOR_SELECTOR = [
  '[class*="author" i]',
  '[class*="customer" i]',
  '[class*="name" i]',
  '[class*="user" i]',
  '[class*="writer" i]',
].join(',');
const CATEGORY_SELECTOR = [
  '[class*="category" i]',
  '[class*="type" i]',
  '[class*="inquiry" i]',
  '[class*="tag" i]',
].join(',');
const STATUS_SELECTOR = [
  '[class*="status" i]',
  '[class*="state" i]',
  '[class*="answered" i]',
  '[class*="reply" i]',
].join(',');
const SOURCE_META_SELECTOR = [
  '[class*="date" i]',
  'time',
  '[class*="author" i]',
  '[class*="customer" i]',
  '[class*="name" i]',
  '[class*="user" i]',
  '[class*="writer" i]',
  '[class*="status" i]',
  '[class*="state" i]',
  '[class*="answered" i]',
  '[class*="reply" i]',
  '[class*="category" i]',
  '[class*="tag" i]',
  '[class*="private" i]',
  '[class*="secret" i]',
  '[class*="lock" i]',
].join(',');
const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, label, [role="button"]';
const SMPS_WRITE_TRIGGER_SELECTOR = '#simpAskQuestion .simpAskQuestionForm-btnOpen';
const QNA_FORM_OPEN_CLASS = 'is-qna-form-open';
const QNA_FORM_OPENING_CLASS = 'is-qna-form-opening';
const QNA_FORM_CLOSING_CLASS = 'is-qna-form-closing';
const QNA_FORM_ANIMATION_DURATION = 200;

const qnaFormAnimationTimers = new WeakMap();
const qnaFormAnimationFrames = new WeakMap();

const CATEGORY_MATCHERS = {
  product: /(product\s*inquiry|product\s*question|상품\s*문의|상품문의)/i,
  restock: /(restock|back\s*in\s*stock|재입고\s*문의|재입고문의|입고)/i,
  size: /(size|sizing|fit|사이즈\s*문의|사이즈문의|허리|waist|length)/i,
  shipping: /(shipping|delivery|배송\s*문의|배송문의)/i,
  other: /(other|etc|기타)/i,
};

const CATEGORY_LABELS = {
  product: 'Product inquiry',
  restock: 'Restock',
  size: 'Size',
  shipping: 'Shipping',
  other: 'Other',
};

const PRIVATE_MATCHER = /(private|secret|locked|비밀)/i;
const ANSWERED_MATCHER = /(answered|answer\s*complete|replied|reply\s*complete|completed|답변\s*완료|답변완료)/i;
const PENDING_MATCHER = /(pending|unanswered|waiting|no\s*answer|답변\s*대기|미답변)/i;
const DATE_MATCHER =
  /(?:20\d{2}[./-]\d{1,2}[./-]\d{1,2}|\d{1,2}[./-]\d{1,2}[./-]20\d{2}|(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\s+\d{1,2},?\s+20\d{2}|\d{1,2}\s+(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\s+20\d{2})/i;

const QNA_TEXT = {
  modalTitle: 'Write Q&A',
  idOrName: 'ID or Name',
  email: 'Email',
  privateQuestion: 'Private question',
  receiveAnswerByEmail: 'Receive answer by email',
  inquiryType: 'Inquiry type',
  question: 'Question',
  questionPlaceholder: 'Type your question here',
  guidelinesTitle: 'Q&A writing guidelines',
  submit: 'Submit',
  cancel: 'Cancel',
  close: 'Close',
  customerFallback: 'Customer',
  guidelines: [
    'For exchanges, returns, or cancellations, please contact us through 1:1 support.',
    'Posts unrelated to the product or purchase process, including abusive, defamatory, or promotional content, may be restricted or removed.',
    'If your message includes personal information such as phone numbers or email addresses, please submit it as a private question.',
  ],
};

const INQUIRY_TYPES = ['Product inquiry', 'Restock', 'Size', 'Shipping', 'Other'];
const QNA_AFTER_LOGIN_INTENT_KEY = 'outfitworksOpenQnaAfterLogin';
const QNA_ACCOUNT_GATE_CLASS = 'is-qna-account-gate-open';
const QNA_ACCOUNT_GATE_CLOSING_CLASS = 'is-qna-account-gate-closing';
const QNA_ACCOUNT_GATE_POPOVER_CLASS = 'is-qna-account-gate-popover';
const QNA_ACCOUNT_GATE_DRAWER_CLASS = 'is-qna-account-gate-drawer';
const QNA_ACCOUNT_GATE_CLOSE_DURATION = 220;
const ACCOUNT_POPOVER_SELECTOR = '#account-popover';
const ACCOUNT_POPOVER_TRIGGER_SELECTOR = '.account-popover .account-button[popovertarget="account-popover"]';
const ACCOUNT_DRAWER_TRIGGER_SELECTOR = '.account-drawer .account-button';
const ACCOUNT_DRAWER_DIALOG_SELECTOR = '.account-drawer__dialog';
const ACCOUNT_SIGN_IN_CONTROL_SELECTOR = [
  '.account-actions__shop-login',
  '.account-actions__shop-login shop-login-button',
  '.account-actions__sign-ins > .account-actions__link.button',
].join(',');

let qnaAccountGateCloseTimer = 0;
let qnaAccountGateLoginReleaseTimer = 0;
let allowQnaAccountGateNativeClose = false;
const originalRowSnapshots = new WeakMap();

const getSections = () => [...document.querySelectorAll(SECTION_SELECTOR)];

const getRows = (section) => [...section.querySelectorAll(ROW_SELECTOR)];

const getLabel = (section, key, fallback) => section.dataset[key] || fallback;

const cleanText = (value = '') => value.replace(/\s+/g, ' ').trim();

const ensureOriginalRowSnapshot = (row) => {
  if (!originalRowSnapshots.has(row)) {
    originalRowSnapshots.set(row, row.cloneNode(true));
  }

  return originalRowSnapshots.get(row);
};

const getSourceRow = (row) => originalRowSnapshots.get(row) || row;

const getQuestionElement = (row) => row.querySelector(QUESTION_SELECTOR) || row.querySelector('p');

const getAnswerElement = (row) => {
  const candidates = [...row.querySelectorAll(ANSWER_SELECTOR)];

  return candidates.find((element) => /answer/i.test(element.className || element.textContent || '')) || null;
};

const getElementText = (row, selector) => {
  const sourceRow = getSourceRow(row);
  const element = [...sourceRow.querySelectorAll(selector)].find((candidate) => {
    return !candidate.className?.toString?.().includes('ow-qna') && cleanText(candidate.textContent);
  });

  return cleanText(element?.textContent || '');
};

const getDatasetDescriptor = (row) => {
  const sourceRow = getSourceRow(row);

  return Object.entries(sourceRow.dataset || {})
    .filter(([key]) => !key.startsWith('owQna') && !key.startsWith('qna'))
    .map(([key, value]) => `${key} ${value}`)
    .join(' ');
};

const inferCategory = (row) => {
  const categoryText = getElementText(row, CATEGORY_SELECTOR);
  const sourceRow = getSourceRow(row);
  const descriptor = [sourceRow.className, sourceRow.getAttribute('aria-label'), getDatasetDescriptor(row), categoryText].join(' ');
  const explicitCategory = Object.entries(CATEGORY_MATCHERS).find(([, matcher]) => matcher.test(descriptor))?.[0];

  if (explicitCategory) {
    return { category: explicitCategory, source: categoryText ? 'selector' : 'attribute' };
  }

  const questionText = getQuestionElement(sourceRow)?.textContent || '';
  const inferredCategory = Object.entries(CATEGORY_MATCHERS).find(([, matcher]) => matcher.test(questionText))?.[0];

  if (inferredCategory) {
    return { category: inferredCategory, source: 'question-text' };
  }

  return { category: 'other', source: 'fallback' };
};

const getRowCategory = (row) => {
  if (row.dataset.qnaCategory) return row.dataset.qnaCategory;
  if (row.dataset.owQnaCategory) return row.dataset.owQnaCategory;

  const { category, source } = inferCategory(row);

  row.dataset.qnaCategory = category;
  row.dataset.qnaCategorySource = source;
  row.dataset.owQnaCategory = category;
  row.dataset.owQnaCategorySource = source;

  return category;
};

const getCategoryLabel = (category) => CATEGORY_LABELS[category] || CATEGORY_LABELS.other;

const getAuthorText = (row) => {
  const explicitAuthor = getElementText(row, AUTHOR_SELECTOR);
  if (explicitAuthor) return explicitAuthor;

  return 'Customer';
};

const maskAuthorValue = (value) => {
  const normalized = cleanText(value).replace(/\s+/g, '');
  if (!normalized || normalized.toLowerCase() === 'customer') return 'Customer';

  const base = normalized.includes('@') ? normalized.split('@')[0] : normalized;
  const visibleLength = Math.min(base.length, base.length > 4 ? 3 : 2);
  const maskLength = Math.max(4, base.length - visibleLength);

  return `${base.slice(0, visibleLength)}${'*'.repeat(maskLength)}`;
};

const isPrivateRow = (row) => {
  const privateText = getElementText(row, '[class*="private" i], [class*="secret" i], [class*="lock" i]');
  const sourceRow = getSourceRow(row);
  const lockElementSelector = [
    '[class*="private" i]',
    '[class*="secret" i]',
    '[class*="lock" i]',
    '[aria-label*="private" i]',
    '[aria-label*="secret" i]',
    '[aria-label*="lock" i]',
    'use[href*="lock" i]',
  ].join(',');
  const hasLockElement = Boolean(
    sourceRow.querySelector(lockElementSelector) || /(?:private|secret|locked|비밀|#?lock)/i.test(sourceRow.innerHTML || '')
  );
  const descriptor = [
    sourceRow.className,
    sourceRow.getAttribute('aria-label'),
    getDatasetDescriptor(row),
    privateText,
    sourceRow.dataset.private,
    sourceRow.dataset.secret,
    hasLockElement ? 'locked private' : '',
    sourceRow.textContent,
  ].join(' ');

  return PRIVATE_MATCHER.test(descriptor);
};

const getDateText = (row) => {
  const sourceRow = getSourceRow(row);
  const explicitDateElement = sourceRow.querySelector('[class*="date" i], time');
  const explicitDate = explicitDateElement?.textContent?.trim();

  if (explicitDate) return explicitDate;

  return (sourceRow.textContent || '').match(DATE_MATCHER)?.[0] || '';
};

const isOwnDecorativeNode = (node) => {
  return node.nodeType === Node.ELEMENT_NODE && node.matches('.ow-qna-row-content, .ow-qna-row-meta, .ow-qna-answer-panel');
};

const hasMeaningfulText = (node) => cleanText(node.textContent || node.nodeValue || '').length > 0;

const getAnswerSourceNodes = (row) => {
  const explicitAnswer = [...row.querySelectorAll('.simpAnswerHolder, [class*="answer" i]')].find((element) => {
    return !element.matches('.ow-qna-answer-panel, .ow-qna-answered-badge, .ow-qna-answer-label');
  });

  if (!explicitAnswer) return [];

  const nodes = [explicitAnswer];
  let sibling = explicitAnswer.nextSibling;

  while (sibling) {
    const next = sibling.nextSibling;

    if (sibling.nodeType === Node.ELEMENT_NODE) {
      if (
        sibling.matches(
          '.simpQuestionHolder, .ow-qna-row-meta, .ow-qna-row-content, .ow-qna-answer-panel, .simpActionHolder, .qa-display, .simPagination'
        )
      ) {
        break;
      }

      if (hasMeaningfulText(sibling)) nodes.push(sibling);
    } else if (sibling.nodeType === Node.TEXT_NODE && hasMeaningfulText(sibling)) {
      nodes.push(sibling);
    }

    sibling = next;
  }

  return nodes;
};

const getAnswerText = (answerPanel) => {
  if (!answerPanel) return '';

  return cleanText(answerPanel.querySelector('.ow-qna-answer-copy')?.textContent || answerPanel.textContent || '').replace(
    /^Answer\s*/i,
    ''
  );
};

const getStatusDescriptor = (row) => {
  const statusText = getElementText(row, STATUS_SELECTOR);
  const sourceRow = getSourceRow(row);

  return [sourceRow.className, sourceRow.getAttribute('aria-label'), getDatasetDescriptor(row), statusText].join(' ');
};

const getAnsweredState = (row, answerPanel) => {
  const descriptor = getStatusDescriptor(row);

  if (PENDING_MATCHER.test(descriptor)) return { answered: false, source: 'status' };
  if (ANSWERED_MATCHER.test(descriptor)) return { answered: true, source: 'status' };

  return { answered: Boolean(getAnswerText(answerPanel)), source: 'answer-body' };
};

const privateIcon = () => `
  <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M5.25 7.5V5.9C5.25 3.8 6.87 2.25 9 2.25s3.75 1.55 3.75 3.65v1.6h.5c.83 0 1.5.67 1.5 1.5v5.25c0 .83-.67 1.5-1.5 1.5h-8.5c-.83 0-1.5-.67-1.5-1.5V9c0-.83.67-1.5 1.5-1.5h.5Zm1.5 0h4.5V5.9c0-1.28-.9-2.15-2.25-2.15S6.75 4.62 6.75 5.9v1.6Z"/>
  </svg>
`;

const closeRows = (section, exceptRow = null) => {
  getRows(section).forEach((row) => {
    if (row === exceptRow) return;

    row.classList.remove('is-open');
    row.setAttribute('aria-expanded', 'false');
  });
};

const syncAnswerPanelHeight = (row) => {
  const panel = row.querySelector('.ow-qna-answer-panel');
  if (!panel) return;

  panel.style.setProperty('--ow-qna-answer-max-height', `${panel.scrollHeight + 32}px`);
};

const toggleRow = (section, row) => {
  if (row.classList.contains('is-private')) return;
  if (!getAnswerElement(row)) return;

  const shouldOpen = !row.classList.contains('is-open');
  if (shouldOpen) syncAnswerPanelHeight(row);

  closeRows(section, row);
  row.classList.toggle('is-open', shouldOpen);
  row.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

  if (shouldOpen) {
    window.requestAnimationFrame(() => syncAnswerPanelHeight(row));
  }
};

const buildAnswerPanel = (section, row) => {
  const existingPanel = row.querySelector('.ow-qna-answer-panel');
  if (existingPanel) return existingPanel;

  const sourceNodes = getAnswerSourceNodes(row);
  if (sourceNodes.length === 0) return null;

  const panel = document.createElement('div');
  panel.className = 'ow-qna-answer-panel';

  const label = document.createElement('span');
  label.className = 'ow-qna-answer-label';
  label.textContent = getLabel(section, 'qnaAnswerLabel', 'Answer');

  const copy = document.createElement('div');
  copy.className = 'ow-qna-answer-copy';

  sourceNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      node.querySelectorAll('.ow-qna-answer-label').forEach((existingLabel) => existingLabel.remove());
    }

    if (hasMeaningfulText(node)) copy.append(node);
    else node.remove();
  });

  panel.append(label, copy);
  row.append(panel);

  return panel;
};

const decorateMeta = (section, row, answerPanel) => {
  let meta = row.querySelector('.ow-qna-row-meta');
  if (!meta) {
    meta = document.createElement('div');
    meta.className = 'ow-qna-row-meta';
    row.append(meta);
  }

  meta.innerHTML = '';

  const dateText = getDateText(row);
  if (dateText) {
    const date = document.createElement('span');
    date.className = 'ow-qna-date';
    date.textContent = dateText;
    meta.append(date);
    row.dataset.qnaDate = dateText;
    row.dataset.owQnaDate = dateText;
  } else {
    delete row.dataset.qnaDate;
    delete row.dataset.owQnaDate;
  }

  const { answered, source } = getAnsweredState(row, answerPanel);

  if (answered) {
    const badge = document.createElement('span');
    badge.className = 'ow-qna-answered-badge';
    badge.textContent = getLabel(section, 'qnaAnsweredLabel', 'Answered');
    meta.append(badge);
  }

  meta.hidden = meta.children.length === 0;

  row.dataset.qnaAnswered = answered ? 'true' : 'false';
  row.dataset.qnaAnsweredSource = source;
  row.dataset.owQnaAnswered = row.dataset.qnaAnswered;
  row.dataset.owQnaAnsweredSource = source;
};

const hideOriginalMetaNodes = (row) => {
  row.querySelectorAll(SOURCE_META_SELECTOR).forEach((element) => {
    if (element.closest('.ow-qna-row-content, .ow-qna-row-meta, .ow-qna-answer-panel')) return;
    if (element.matches('.simpQuestionHolder, .simpAnswerHolder, [class*="answer" i]')) return;
    if (element.querySelector('.simpQuestionHolder, .simpAnswerHolder, [class*="answer" i]')) return;

    element.hidden = true;
    element.dataset.owQnaSourceMetaHidden = 'true';
  });
};

const decoratePrivateRow = (section, row) => {
  if (!isPrivateRow(row)) return false;

  row.classList.add('is-private');
  row.dataset.qnaPrivate = 'true';
  row.dataset.owQnaPrivate = 'true';
  row.setAttribute('aria-expanded', 'false');

  const question = getQuestionElement(row);
  if (question && question.dataset.owQnaPrivateDecorated !== 'true') {
    question.dataset.owQnaPrivateDecorated = 'true';
    question.innerHTML = `
      <span class="ow-qna-private-message">
        ${privateIcon()}
        <span>${getLabel(section, 'qnaPrivateLabel', 'Private question')}</span>
      </span>
    `;
  }

  row.querySelectorAll('.ow-qna-answer-panel, .simpAnswerHolder, [class*="answer" i]').forEach((answer) => {
    if (answer.matches('.ow-qna-answered-badge')) return;
    answer.hidden = true;
    if (answer.matches('.ow-qna-answer-panel')) answer.remove();
  });

  return true;
};

const ensureRowContent = (row) => {
  let content = row.querySelector('.ow-qna-row-content');
  const question = getQuestionElement(row);

  if (content) {
    const category = getRowCategory(row);
    let categoryLabel = content.querySelector('.ow-qna-category-label');

    if (!categoryLabel) {
      categoryLabel = document.createElement('span');
      categoryLabel.className = 'ow-qna-category-label';

      const author = content.querySelector('.ow-qna-author');
      if (author) author.after(categoryLabel);
      else content.prepend(categoryLabel);
    }

    categoryLabel.textContent = getCategoryLabel(category);
    categoryLabel.hidden = false;
    categoryLabel.removeAttribute('aria-hidden');
    categoryLabel.style.removeProperty('display');

    if (question && !content.contains(question)) {
      question.classList.add('ow-qna-question-text');
      content.append(question);
    }

    return content;
  }

  if (!question) return null;

  content = document.createElement('div');
  content.className = 'ow-qna-row-content';

  const author = document.createElement('span');
  author.className = 'ow-qna-author';
  author.textContent = maskAuthorValue(getAuthorText(row));

  const category = getRowCategory(row);
  const categoryLabel = document.createElement('span');
  categoryLabel.className = 'ow-qna-category-label';
  categoryLabel.textContent = getCategoryLabel(category);
  categoryLabel.hidden = false;

  question.classList.add('ow-qna-question-text');

  content.append(author, categoryLabel, question);

  const firstNode = [...row.childNodes].find((node) => !isOwnDecorativeNode(node));
  row.insertBefore(content, firstNode || row.firstChild);

  [...row.childNodes].forEach((node) => {
    if (node === content || isOwnDecorativeNode(node)) return;
    if (node.nodeType === Node.TEXT_NODE && !hasMeaningfulText(node)) node.remove();
  });

  return content;
};

const removeEmptyStrayNodes = (row) => {
  [...row.children].forEach((element) => {
    if (isOwnDecorativeNode(element) || element.matches('.simpQuestionHolder')) return;
    if (!hasMeaningfulText(element)) element.remove();
  });
};

const decorateRow = (section, row) => {
  ensureOriginalRowSnapshot(row);

  if (row.dataset.owQnaEnhanced !== 'true') {
    row.dataset.owQnaEnhanced = 'true';
    row.setAttribute('role', 'button');
    row.setAttribute('tabindex', '0');
    row.setAttribute('aria-expanded', 'false');

    row.addEventListener('click', (event) => {
      const interactiveTarget = event.target.closest(INTERACTIVE_SELECTOR);
      if (interactiveTarget && interactiveTarget !== row) return;
      toggleRow(section, row);
    });

    row.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggleRow(section, row);
    });
  }

  const category = getRowCategory(row);
  const privateState = isPrivateRow(row);
  row.dataset.qnaRow = 'true';
  row.dataset.qnaCategory = category;
  row.dataset.qnaCategorySource = row.dataset.qnaCategorySource || row.dataset.owQnaCategorySource || inferCategory(row).source;
  row.dataset.qnaPrivate = privateState ? 'true' : 'false';
  row.dataset.owQnaCategory = category;
  row.dataset.owQnaCategorySource = row.dataset.qnaCategorySource;
  row.dataset.owQnaPrivate = row.dataset.qnaPrivate;
  row.classList.toggle('is-private', privateState);

  ensureRowContent(row);

  const answerPanel = buildAnswerPanel(section, row);
  if (answerPanel) syncAnswerPanelHeight(row);
  decorateMeta(section, row, answerPanel);
  hideOriginalMetaNodes(row);
  removeEmptyStrayNodes(row);

  if (decoratePrivateRow(section, row)) return;
};

const applyActiveFilter = (section, filters, value = 'all') => {
  filters.querySelectorAll('[data-ow-qna-filter]').forEach((filterButton) => {
    filterButton.classList.toggle('is-active', filterButton.dataset.owQnaFilter === value);
  });

  getRows(section).forEach((row) => {
    row.hidden = value !== 'all' && getRowCategory(row) !== value;
    row.classList.remove('is-open');
    row.setAttribute('aria-expanded', 'false');
  });
};

const setupFilters = (section) => {
  const filters = section.querySelector('[data-ow-qna-filters]');
  if (!filters) return;

  const rows = getRows(section);
  filters.hidden = rows.length === 0;

  const activeValue =
    section.dataset.owQnaActiveFilter ||
    filters.querySelector('[data-ow-qna-filter].is-active')?.dataset.owQnaFilter ||
    'all';

  section.dataset.owQnaActiveFilter = activeValue;
  applyActiveFilter(section, filters, activeValue);

  if (filters.dataset.owQnaBound === 'true') return;
  filters.dataset.owQnaBound = 'true';

  filters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ow-qna-filter]');
    if (!button) return;

    const value = button.dataset.owQnaFilter;
    section.dataset.owQnaActiveFilter = value;
    applyActiveFilter(section, filters, value);
  });
};

const clearFormAnimationState = (section) => {
  const timer = qnaFormAnimationTimers.get(section);
  if (timer) window.clearTimeout(timer);
  qnaFormAnimationTimers.delete(section);

  const frame = qnaFormAnimationFrames.get(section);
  if (frame) window.cancelAnimationFrame(frame);
  qnaFormAnimationFrames.delete(section);
};

const finishCloseForm = (section) => {
  const formContainer = section.querySelector('#simpAskForm_container');

  section.classList.remove(QNA_FORM_OPEN_CLASS, QNA_FORM_OPENING_CLASS, QNA_FORM_CLOSING_CLASS);
  if (formContainer) formContainer.style.display = 'none';
};

const openForm = (section) => {
  const formContainer = section.querySelector('#simpAskForm_container');
  const form = formContainer?.querySelector('form');
  if (!formContainer) return false;

  clearFormAnimationState(section);
  section.classList.remove(QNA_FORM_CLOSING_CLASS, QNA_FORM_OPEN_CLASS);
  section.classList.add(QNA_FORM_OPENING_CLASS);
  formContainer.style.display = 'flex';

  const frame = window.requestAnimationFrame(() => {
    section.classList.add(QNA_FORM_OPEN_CLASS);
    section.classList.remove(QNA_FORM_OPENING_CLASS);
    qnaFormAnimationFrames.delete(section);

    if (form) {
      form.setAttribute('role', 'dialog');
      form.setAttribute('aria-modal', 'true');
    }

    const firstControl = formContainer.querySelector('textarea, input:not([type="hidden"]), select, button');
    firstControl?.focus({ preventScroll: true });
  });

  qnaFormAnimationFrames.set(section, frame);
  return true;
};

const closeForm = (section, options = {}) => {
  const formContainer = section.querySelector('#simpAskForm_container');
  const form = formContainer?.querySelector('form');
  if (!formContainer) return;

  clearFormAnimationState(section);

  if (options.immediate) {
    if (form) {
      form.removeAttribute('role');
      form.removeAttribute('aria-modal');
    }
    finishCloseForm(section);
    return;
  }

  if (
    !section.classList.contains(QNA_FORM_OPEN_CLASS) &&
    !section.classList.contains(QNA_FORM_OPENING_CLASS)
  ) {
    finishCloseForm(section);
    return;
  }

  formContainer.style.display = 'flex';
  section.classList.remove(QNA_FORM_OPEN_CLASS, QNA_FORM_OPENING_CLASS);
  section.classList.add(QNA_FORM_CLOSING_CLASS);

  const timer = window.setTimeout(() => {
    if (form) {
      form.removeAttribute('role');
      form.removeAttribute('aria-modal');
    }
    finishCloseForm(section);
    qnaFormAnimationTimers.delete(section);
  }, QNA_FORM_ANIMATION_DURATION);

  qnaFormAnimationTimers.set(section, timer);
};

const syncFieldStrokeColor = (form) => {
  const fields = form.querySelector('.ow-qna-form-fields');
  const emailInput = form.querySelector('input[name="email"], input[type="email"]');
  if (!fields || !emailInput) return;

  const borderColor = window.getComputedStyle(emailInput).borderColor;
  if (borderColor && borderColor !== 'rgba(0, 0, 0, 0)' && borderColor !== 'transparent') {
    fields.style.setProperty('--ow-qna-field-border-color', borderColor);
  }
};

const syncFormState = (section) => {
  const formContainer = section.querySelector('#simpAskForm_container');
  if (!formContainer) return;
  if (section.classList.contains(QNA_FORM_CLOSING_CLASS)) return;

  const form = formContainer.querySelector('form');
  if (form) {
    syncCustomerFields(section, form.querySelector('input[name="name"]'), form.querySelector('input[name="email"]'));
    syncFieldStrokeColor(form);
  }

  const isRequestedOpen = formContainer.style.display && formContainer.style.display !== 'none';
  if (
    isRequestedOpen &&
    !section.classList.contains(QNA_FORM_OPEN_CLASS) &&
    !section.classList.contains(QNA_FORM_OPENING_CLASS)
  ) {
    openForm(section);
  }
};

const openFormFallback = (section) => {
  const formContainer = section.querySelector('#simpAskForm_container');
  if (!formContainer) return false;

  return openForm(section);
};

const findSmpsWriteTrigger = (section) => section.querySelector(SMPS_WRITE_TRIGGER_SELECTOR);

const clickSmpsWriteTrigger = (section) => {
  const trigger = findSmpsWriteTrigger(section);

  if (trigger) {
    trigger.click();
    window.setTimeout(() => syncFormState(section), 0);
    window.setTimeout(() => syncFormState(section), 120);
    return true;
  }

  if (openFormFallback(section)) return true;

  console.warn('[Product Q&A] SMPS ask question trigger not found.');
  return false;
};

const isCustomerLoggedIn = (section) => {
  return section.dataset.customerLoggedIn === 'true' || section.dataset.qnaLoggedIn === 'true';
};

const isVisibleElement = (element) => {
  if (!element) return false;

  const styles = window.getComputedStyle(element);
  if (styles.display === 'none' || styles.visibility === 'hidden') return false;

  return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

const getAccountPanel = () => document.querySelector(ACCOUNT_POPOVER_SELECTOR);

const getAccountDrawerDialog = () => document.querySelector(ACCOUNT_DRAWER_DIALOG_SELECTOR);

const isAccountPopoverOpen = (panel) => {
  return Boolean(panel?.matches(':popover-open') || panel?.classList.contains(':popover-open'));
};

const isAccountDrawerOpen = (dialog) => Boolean(dialog?.open);

const isAccountSurfaceOpen = (surface) => {
  if (!surface) return false;
  if (surface.matches?.(ACCOUNT_POPOVER_SELECTOR)) return isAccountPopoverOpen(surface);
  if (surface.matches?.(ACCOUNT_DRAWER_DIALOG_SELECTOR)) return isAccountDrawerOpen(surface);
  return false;
};

const getOpenAccountSurface = () => {
  const panel = getAccountPanel();
  if (isAccountPopoverOpen(panel)) return panel;

  const drawer = getAccountDrawerDialog();
  if (isAccountDrawerOpen(drawer)) return drawer;

  return null;
};

const removeQnaAccountGateContent = () => {
  document.querySelectorAll('[data-ow-qna-account-gate]').forEach((element) => element.remove());
};

const clearQnaAccountGateCloseTimer = () => {
  if (!qnaAccountGateCloseTimer) return;

  window.clearTimeout(qnaAccountGateCloseTimer);
  qnaAccountGateCloseTimer = 0;
};

const clearQnaAccountGateLoginReleaseTimer = () => {
  if (!qnaAccountGateLoginReleaseTimer) return;

  window.clearTimeout(qnaAccountGateLoginReleaseTimer);
  qnaAccountGateLoginReleaseTimer = 0;
};

const removeQnaAccountGateState = () => {
  removeQnaAccountGateContent();
  document.body.classList.remove(
    QNA_ACCOUNT_GATE_CLASS,
    QNA_ACCOUNT_GATE_CLOSING_CLASS,
    QNA_ACCOUNT_GATE_POPOVER_CLASS,
    QNA_ACCOUNT_GATE_DRAWER_CLASS
  );
};

const releaseQnaAccountGateForSignIn = () => {
  clearQnaAccountGateCloseTimer();
  clearQnaAccountGateLoginReleaseTimer();
  allowQnaAccountGateNativeClose = true;

  qnaAccountGateLoginReleaseTimer = window.setTimeout(() => {
    removeQnaAccountGateState();

    qnaAccountGateLoginReleaseTimer = window.setTimeout(() => {
      allowQnaAccountGateNativeClose = false;
      qnaAccountGateLoginReleaseTimer = 0;
    }, 1200);
  }, 0);
};

const finishQnaAccountGateClose = () => {
  const panel = getAccountPanel();
  const drawer = getAccountDrawerDialog();
  qnaAccountGateCloseTimer = 0;

  allowQnaAccountGateNativeClose = true;

  try {
    if (panel && isAccountPopoverOpen(panel) && typeof panel.hidePopover === 'function') {
      panel.hidePopover();
    }

    if (drawer?.open) {
      const drawerComponent = drawer.closest('dialog-component');

      if (drawerComponent && typeof drawerComponent.closeDialog === 'function') {
        drawerComponent.closeDialog();
      } else {
        drawer.close();
      }
    }
  } finally {
    allowQnaAccountGateNativeClose = false;
  }

  removeQnaAccountGateState();
};

const closeQnaAccountGate = ({ immediate = false } = {}) => {
  const body = document.body;

  if (!body.classList.contains(QNA_ACCOUNT_GATE_CLASS) && !body.classList.contains(QNA_ACCOUNT_GATE_CLOSING_CLASS)) {
    return;
  }

  if (body.classList.contains(QNA_ACCOUNT_GATE_CLOSING_CLASS) && qnaAccountGateCloseTimer) return;

  body.classList.add(QNA_ACCOUNT_GATE_CLOSING_CLASS);

  if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    clearQnaAccountGateCloseTimer();
    finishQnaAccountGateClose();
    return;
  }

  clearQnaAccountGateCloseTimer();
  qnaAccountGateCloseTimer = window.setTimeout(finishQnaAccountGateClose, QNA_ACCOUNT_GATE_CLOSE_DURATION);
};

const ensureQnaAccountGateContent = (surface = getOpenAccountSurface() || getAccountPanel() || getAccountDrawerDialog()) => {
  const mainMenu = surface?.querySelector('.account-actions__main-menu');
  if (!mainMenu) return;

  if (!mainMenu.querySelector('[data-ow-qna-account-gate]')) {
    const gate = document.createElement('div');
    gate.className = 'ow-qna-account-gate';
    gate.dataset.owQnaAccountGate = 'true';
    gate.innerHTML = `
      <button type="button" class="ow-qna-account-gate__close" data-ow-qna-account-gate-close aria-label="Close">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </button>
      <h3 class="ow-qna-account-gate__title">Sign in required</h3>
      <p class="ow-qna-account-gate__message">Please sign in to write a Q&A.</p>
    `;
    mainMenu.prepend(gate);
  }

  if (surface.dataset.owQnaAccountGateBound === 'true') return;
  surface.dataset.owQnaAccountGateBound = 'true';

  surface.addEventListener('click', (event) => {
    if (event.target.closest('[data-ow-qna-account-gate-close]')) {
      event.preventDefault();
      closeQnaAccountGate();
      return;
    }

    if (event.target.closest(ACCOUNT_SIGN_IN_CONTROL_SELECTOR)) {
      releaseQnaAccountGateForSignIn();
    }
  }, true);

  if (surface.matches?.(ACCOUNT_POPOVER_SELECTOR)) {
    surface.addEventListener('beforetoggle', (event) => {
      if (event.newState !== 'closed') return;
      if (!document.body.classList.contains(QNA_ACCOUNT_GATE_CLASS)) return;
      if (allowQnaAccountGateNativeClose) return;

      event.preventDefault();
      closeQnaAccountGate();
    });

    surface.addEventListener('toggle', () => {
      if (isAccountPopoverOpen(surface)) return;
      if (document.body.classList.contains(QNA_ACCOUNT_GATE_CLOSING_CLASS)) return;

      removeQnaAccountGateState();
    });
  }

  if (surface.matches?.(ACCOUNT_DRAWER_DIALOG_SELECTOR)) {
    surface.addEventListener('cancel', (event) => {
      if (!document.body.classList.contains(QNA_ACCOUNT_GATE_CLASS)) return;
      if (allowQnaAccountGateNativeClose) return;

      event.preventDefault();
      closeQnaAccountGate();
    });

    surface.addEventListener('close', () => {
      if (document.body.classList.contains(QNA_ACCOUNT_GATE_CLOSING_CLASS)) return;

      removeQnaAccountGateState();
    });
  }
};

const findAccountPopupTrigger = () => {
  const popoverTrigger = document.querySelector(ACCOUNT_POPOVER_TRIGGER_SELECTOR);
  const drawerTriggers = [...document.querySelectorAll(ACCOUNT_DRAWER_TRIGGER_SELECTOR)];
  const visiblePopoverTrigger = isVisibleElement(popoverTrigger) ? popoverTrigger : null;
  const visibleDrawerTrigger = drawerTriggers.find(isVisibleElement);

  if (visiblePopoverTrigger) return visiblePopoverTrigger;
  if (visibleDrawerTrigger) return visibleDrawerTrigger;

  return popoverTrigger || drawerTriggers[0] || null;
};

const getAccountSurfaceForTrigger = (trigger) => {
  if (trigger?.closest('.account-drawer')) return getAccountDrawerDialog();
  return getAccountPanel();
};

const openExistingAccountPopup = () => {
  const trigger = findAccountPopupTrigger();

  if (!trigger) {
    console.warn('[Product Q&A] Account popup trigger not found.');
    return false;
  }

  clearQnaAccountGateCloseTimer();
  clearQnaAccountGateLoginReleaseTimer();
  allowQnaAccountGateNativeClose = false;
  const isDrawerTrigger = Boolean(trigger.closest('.account-drawer'));
  document.body.classList.remove(
    QNA_ACCOUNT_GATE_CLOSING_CLASS,
    QNA_ACCOUNT_GATE_POPOVER_CLASS,
    QNA_ACCOUNT_GATE_DRAWER_CLASS
  );
  document.body.classList.add(QNA_ACCOUNT_GATE_CLASS);
  document.body.classList.toggle(QNA_ACCOUNT_GATE_DRAWER_CLASS, isDrawerTrigger);
  document.body.classList.toggle(QNA_ACCOUNT_GATE_POPOVER_CLASS, !isDrawerTrigger);

  let surface = getAccountSurfaceForTrigger(trigger);
  if (!isAccountSurfaceOpen(surface)) {
    trigger.click();
  }

  surface = getAccountSurfaceForTrigger(trigger);
  if (surface?.matches?.(ACCOUNT_POPOVER_SELECTOR) && !isAccountPopoverOpen(surface) && typeof surface.showPopover === 'function') {
    surface.showPopover();
  }

  ensureQnaAccountGateContent(surface);

  window.setTimeout(() => {
    const openSurface = getOpenAccountSurface() || surface;
    openSurface?.querySelector('shop-login-button, .account-actions__sign-ins a, [data-ow-qna-account-gate-close]')?.focus?.({
      preventScroll: true,
    });
  }, 0);

  return true;
};

const storeQnaWriteIntent = () => {
  try {
    window.sessionStorage.setItem(QNA_AFTER_LOGIN_INTENT_KEY, 'true');
  } catch (error) {
    console.warn('[Product Q&A] Could not store post-login Q&A intent.', error);
  }
};

const consumeQnaWriteIntent = () => {
  try {
    if (window.sessionStorage.getItem(QNA_AFTER_LOGIN_INTENT_KEY) !== 'true') return false;
    window.sessionStorage.removeItem(QNA_AFTER_LOGIN_INTENT_KEY);
    return true;
  } catch (error) {
    console.warn('[Product Q&A] Could not read post-login Q&A intent.', error);
    return false;
  }
};

const setupWriteButton = (section) => {
  const button = section.querySelector('[data-ow-qna-write], [data-product-inquiry-write-trigger]');
  if (!button || button.dataset.owQnaBound === 'true') return;

  button.dataset.owQnaBound = 'true';
  button.addEventListener('click', (event) => {
    event.preventDefault();

    if (!isCustomerLoggedIn(section)) {
      storeQnaWriteIntent();
      openExistingAccountPopup();
      return;
    }

    closeQnaAccountGate();
    clickSmpsWriteTrigger(section);
  });
};

const ensureId = (element, prefix) => {
  if (element.id) return element.id;

  element.id = `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
  return element.id;
};

const createFieldRow = (labelText, control, className = '') => {
  const row = document.createElement('div');
  row.className = `ow-qna-field-row ${className}`.trim();

  const label = document.createElement('label');
  label.className = 'ow-qna-field-label';
  label.textContent = labelText;

  if (control instanceof HTMLElement && control.matches('input, select, textarea')) {
    label.setAttribute('for', ensureId(control, 'ow-qna-field'));
  }

  const field = document.createElement('div');
  field.className = 'ow-qna-field-control';
  field.append(control);

  row.append(label, field);

  return row;
};

const getEmailLocalPart = (email = '') => email.trim().split('@')[0] || '';

const getCustomerIdentity = (section, nameInput, emailInput) => {
  return (
    section.dataset.qnaCustomerName?.trim() ||
    nameInput?.value?.trim() ||
    getEmailLocalPart(section.dataset.qnaCustomerEmail || '') ||
    getEmailLocalPart(emailInput?.value || '') ||
    QNA_TEXT.customerFallback
  );
};

const maskCustomerValue = (value) => {
  const normalized = (value || '').trim().replace(/\s+/g, '');
  if (!normalized) return QNA_TEXT.customerFallback;

  const visibleLength = Math.min(normalized.length, normalized.length > 4 ? 3 : 2);
  const maskLength = Math.max(8, normalized.length - visibleLength);

  return `${normalized.slice(0, visibleLength)}${'*'.repeat(maskLength)}`;
};

const syncCustomerFields = (section, nameInput, emailInput) => {
  if (emailInput && !emailInput.value && section.dataset.qnaCustomerEmail) {
    emailInput.value = section.dataset.qnaCustomerEmail;
  }

  const customerIdentity = getCustomerIdentity(section, nameInput, emailInput);

  if (
    nameInput &&
    (!nameInput.value || nameInput.value === QNA_TEXT.customerFallback || section.dataset.qnaCustomerName?.trim())
  ) {
    nameInput.value = customerIdentity;
  }

  const display = section.querySelector('.ow-qna-customer-display__value');
  if (display) display.textContent = maskCustomerValue(customerIdentity);
};

const createCustomerDisplay = (section, nameInput, emailInput) => {
  syncCustomerFields(section, nameInput, emailInput);

  const wrapper = document.createElement('div');
  wrapper.className = 'ow-qna-customer-display';

  const value = document.createElement('span');
  value.className = 'ow-qna-customer-display__value';
  value.textContent = maskCustomerValue(getCustomerIdentity(section, nameInput, emailInput));

  nameInput.classList.add('ow-qna-submission-field');
  nameInput.type = 'hidden';
  nameInput.readOnly = true;
  nameInput.tabIndex = -1;
  nameInput.setAttribute('aria-hidden', 'true');

  wrapper.append(value, nameInput);

  return wrapper;
};

const createCheckbox = ({ name, label, checked = false, datasetKey }) => {
  const checkboxLabel = document.createElement('label');
  checkboxLabel.className = 'ow-qna-checkbox-label';

  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.name = name;
  checkbox.value = '1';
  checkbox.checked = checked;
  checkbox.dataset[datasetKey] = 'true';

  const text = document.createElement('span');
  text.textContent = label;

  checkboxLabel.append(checkbox, text);

  return checkboxLabel;
};

const createInquiryTypeSelect = () => {
  const select = document.createElement('select');
  select.name = 'inquiry_type';
  select.dataset.owQnaInquiryType = 'true';

  INQUIRY_TYPES.forEach((type) => {
    const option = document.createElement('option');
    option.value = type;
    option.textContent = type;
    select.append(option);
  });

  return select;
};

const createGuidelines = () => {
  const guidelines = document.createElement('div');
  guidelines.className = 'ow-qna-guidelines';

  const title = document.createElement('h4');
  title.className = 'ow-qna-guidelines-title';
  title.textContent = QNA_TEXT.guidelinesTitle;

  const list = document.createElement('ul');
  list.className = 'ow-qna-guidelines-list';

  QNA_TEXT.guidelines.forEach((text) => {
    const item = document.createElement('li');
    item.textContent = text;
    list.append(item);
  });

  guidelines.append(title, list);

  return guidelines;
};

const moveMessagesIntoForm = (section, form) => {
  let messages = form.querySelector('.ow-qna-messages');
  if (!messages) {
    messages = document.createElement('div');
    messages.className = 'ow-qna-messages';
    const title = form.querySelector('.ow-qna-modal-title');
    title?.after(messages);
  }

  section.querySelectorAll('#simpAskQuestion .simpAsk-error-msg, #simpAskQuestion .simpAsk-success-msg').forEach((message) => {
    if (message.parentElement !== messages) messages.append(message);
  });
};

const normalizeSmpsFormText = (form) => {
  const nameInput = form.querySelector('input[name="name"]');
  const emailInput = form.querySelector('input[name="email"]');
  const questionTextarea = form.querySelector('textarea[name="question"]');
  const submitInput = form.querySelector('input[type="submit"]');
  const cancelButton = form.querySelector('.simpAskForm-cancel-btn');
  const closeButton = form.querySelector('.ow-qna-modal-close');

  if (nameInput) {
    nameInput.placeholder = QNA_TEXT.idOrName;
    nameInput.title = QNA_TEXT.idOrName;
  }

  if (emailInput) {
    emailInput.placeholder = QNA_TEXT.email;
    emailInput.title = QNA_TEXT.email;
  }

  if (questionTextarea) {
    questionTextarea.placeholder = QNA_TEXT.questionPlaceholder;
    questionTextarea.title = QNA_TEXT.question;
  }

  if (submitInput) submitInput.value = QNA_TEXT.submit;
  if (cancelButton) cancelButton.textContent = QNA_TEXT.cancel;
  if (closeButton) closeButton.setAttribute('aria-label', QNA_TEXT.close);
};

const setupFormFields = (section, form) => {
  normalizeSmpsFormText(form);
  moveMessagesIntoForm(section, form);
  syncCustomerFields(section, form.querySelector('input[name="name"]'), form.querySelector('input[name="email"]'));

  if (form.dataset.owQnaFieldsEnhanced === 'true') return;

  const originalGroup = [...form.children].find((element) => {
    return element.tagName === 'DIV' && !element.classList.contains('ow-qna-messages') && !element.classList.contains('simpAskSubmitForm');
  });
  const hiddenControls = [...form.querySelectorAll('input[type="hidden"], input.questionMarkFormat')];
  const nameInput = form.querySelector('input[name="name"]');
  const emailInput = form.querySelector('input[name="email"]');
  const questionTextarea = form.querySelector('textarea[name="question"]');
  const submitRow = form.querySelector('.simpAskSubmitForm');

  if (!nameInput || !emailInput || !questionTextarea || !submitRow) return;

  const fields = document.createElement('div');
  fields.className = 'ow-qna-form-fields';

  hiddenControls.forEach((control) => form.append(control));

  const checkboxGroup = document.createElement('div');
  checkboxGroup.className = 'ow-qna-checkboxes';
  checkboxGroup.append(
    createCheckbox({
      name: 'private_question',
      label: QNA_TEXT.privateQuestion,
      datasetKey: 'owQnaPrivate',
    }),
    createCheckbox({
      name: 'receive_answer_by_email',
      label: QNA_TEXT.receiveAnswerByEmail,
      checked: true,
      datasetKey: 'owQnaReceiveEmail',
    })
  );

  const emailGroup = document.createElement('div');
  emailGroup.className = 'ow-qna-email-group';
  emailGroup.append(emailInput, checkboxGroup);

  fields.append(
    createFieldRow(QNA_TEXT.idOrName, createCustomerDisplay(section, nameInput, emailInput), 'ow-qna-field-row--name'),
    createFieldRow(QNA_TEXT.email, emailGroup, 'ow-qna-field-row--email'),
    createFieldRow(QNA_TEXT.inquiryType, createInquiryTypeSelect(), 'ow-qna-field-row--type'),
    createFieldRow(QNA_TEXT.question, questionTextarea, 'ow-qna-field-row--question')
  );

  originalGroup?.remove();
  form.append(fields, createGuidelines(), submitRow);
  form.dataset.owQnaFieldsEnhanced = 'true';
};

const setupForm = (section) => {
  const formContainer = section.querySelector('#simpAskForm_container');
  const form = formContainer?.querySelector('form');
  if (!formContainer || !form) return;

  if (!form.querySelector('.ow-qna-modal-title')) {
    const title = document.createElement('h3');
    title.className = 'ow-qna-modal-title';
    title.textContent = QNA_TEXT.modalTitle;
    form.prepend(title);
  }

  if (!form.querySelector('.ow-qna-modal-close')) {
    const close = document.createElement('button');
    close.className = 'ow-qna-modal-close';
    close.type = 'button';
    close.setAttribute('aria-label', QNA_TEXT.close);
    close.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    `;
    form.prepend(close);
  }

  setupFormFields(section, form);

  if (formContainer.dataset.owQnaBound === 'true') return;
  formContainer.dataset.owQnaBound = 'true';

  formContainer.addEventListener('click', (event) => {
    if (event.target === formContainer || event.target.closest('.ow-qna-modal-close, .simpAskForm-cancel-btn')) {
      event.preventDefault();
      closeForm(section);
    }
  });

  form.addEventListener('submit', () => {
    const success = formContainer.querySelector('.simpAsk-success-msg');
    let checks = 0;
    const timer = window.setInterval(() => {
      checks += 1;
      const hasSuccess = success && getComputedStyle(success).display !== 'none' && success.textContent.trim();
      if (hasSuccess) {
        window.clearInterval(timer);
        window.setTimeout(() => closeForm(section), 1400);
      }

      if (checks > 20) window.clearInterval(timer);
    }, 400);
  });
};

const enhanceSection = (section) => {
  setupWriteButton(section);
  setupForm(section);
  getRows(section).forEach((row) => decorateRow(section, row));
  setupFilters(section);
};

const resumeQnaWriteAfterLogin = (section) => {
  if (!isCustomerLoggedIn(section) || !consumeQnaWriteIntent()) return;

  window.setTimeout(() => {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    clickSmpsWriteTrigger(section);
  }, 350);
};

const hasElementMutation = (mutations) => {
  return mutations.some(({ addedNodes, removedNodes }) => {
    return [...addedNodes, ...removedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE);
  });
};

const runEnhanceSection = (section) => {
  if (section.dataset.owQnaEnhancing === 'true') return;

  section.dataset.owQnaEnhancing = 'true';

  try {
    enhanceSection(section);
  } finally {
    section.dataset.owQnaEnhancing = 'false';
  }
};

const observeSection = (section) => {
  if (section.dataset.owQnaObserver === 'true') return;
  section.dataset.owQnaObserver = 'true';

  let frameId = 0;
  const options = { childList: true, subtree: true };
  const observer = new MutationObserver((mutations) => {
    if (!hasElementMutation(mutations) || frameId) return;

    frameId = window.requestAnimationFrame(() => {
      frameId = 0;
      observer.disconnect();
      runEnhanceSection(section);
      observer.observe(section, options);
    });
  });

  observer.observe(section, options);
};

const init = () => {
  getSections().forEach((section) => {
    runEnhanceSection(section);
    observeSection(section);
    resumeQnaWriteAfterLogin(section);
  });
};

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  if (document.body.classList.contains(QNA_ACCOUNT_GATE_CLASS)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    closeQnaAccountGate();
    return;
  }

  getSections().forEach((section) => {
    if (
      section.classList.contains(QNA_FORM_OPEN_CLASS) ||
      section.classList.contains(QNA_FORM_OPENING_CLASS)
    ) {
      closeForm(section);
    }
  });
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
